import * as React from 'react'

import { ShiftsFeatureFlagFragment } from 'generated/resources/graphql'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'
import type { FeatureAvailabilityType } from 'modules/core/hooks/useFeatureAvailability'

import type { EnabledFeaturesState, FeaturesDispatch } from './reducers/enabledFeatures'
import reducer, { initialEnabledFeaturesState } from './reducers/enabledFeatures'

type Context = [EnabledFeaturesState, FeaturesDispatch]

const { context: EnabledFeaturesContext, hook: useEnabledFeatures } = createContext<Context>()

interface ProviderType {
  featureFlags: ShiftsFeatureFlagFragment[]
  features: FeatureAvailabilityType[]
}

const EnabledFeaturesProvider = ({
  features,
  children,
  featureFlags,
}: React.PropsWithChildren<ProviderType>) => {
  const memoizedReducer = useCallback(reducer, [])
  const [state, dispatch] = React.useReducer(
    memoizedReducer,
    initialEnabledFeaturesState({
      featureFlags,
      features,
    })
  )

  return (
    <EnabledFeaturesContext.Provider value={[state, dispatch]}>
      {children}
    </EnabledFeaturesContext.Provider>
  )
}

export { EnabledFeaturesProvider, useEnabledFeatures }
